import React from 'react'

const SectionBox = ({ title, children, className = '' }) => (
  <div className={`border rounded-3 p-3 p-md-4 h-100 bg-white ${className}`}>
    {title && <h6 className="fw-bold mb-3">{title}</h6>}
    {children}
  </div>
)

export default SectionBox
